<template>
  <div class="media-report">
    <div class="headline">
      <h1>{{$t("news.mediaReport.headlineTitle")}}</h1>
      <p>{{$t("news.mediaReport.headlineP")}}</p>
    </div>

    <el-row class="news-lists" v-for="(item,index) in tabLists" :key="index"  @click.native="toDetail(item)">
      <el-col :span="5">
        <div class="date">
          <p>{{item.createTime.slice(5)}}</p>
          <p>{{item.createTime.slice(0,4)}}</p>
        </div>
      </el-col>
      <el-col :span="19">
        <div class="des">
          <h3>{{item.title}}</h3>
          <p>{{item.smallContent}}</p>
          <p>{{$t("news.parameter.read")}}</p>
        </div>
      </el-col>
    </el-row>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageReq.page"
      :limit.sync="pageReq.size"
      @pagination="getList"
    />
  </div>
</template>
<script>
import {getnewlist} from "../../api/news"
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      total: 0,// 总条数
      pageReq: {
        page: 1,
        size: 10,
      },
      tabLists:[]
    };
  },
  computed:{
    ...mapGetters(['language'])
  },
  mounted() {
    this.getList();
    
  },
  methods: {
    getList(){
      const pageReq = {...this.pageReq};
      pageReq.page -= 1;
      getnewlist(this.language,{contentType:'2'},pageReq).then(res =>{
        const { content, totalElements } = res;
        this.tabLists = content;
        this.total = totalElements;
      })
    },
    toDetail(item) {
      if(item.wxUrl){
        window.open(item.wxUrl,false);
      }else{
        this.$router.push({ path: `/news/detail/${item.id}` });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$cblue: #0054a7;
.media-report{
  
  .news-lists{
    padding: 20px 0;
    border-bottom: 1px solid #E2E2E2;
    .date{
      margin-left: 50%;
      transform: translateX(-50%);
      p:nth-of-type(1) {
        font-size: 30px;
      }
    }
    .des{
      h3{
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p:nth-of-type(1) {
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p:nth-of-type(2) {
        color: $cblue;
      }
    }
    &:hover{
      cursor: pointer;
      .date{
        color: $cblue;
      }
      .des{
        h3{
          color: $cblue;
        }
      }
      
    }
  }
  @media screen and (max-width:768px){
    .news-lists{
      .date{
        margin-left: 0;
        transform: translateX(0);
        p:nth-of-type(1) {
          font-size: 18px;
        }
      }
    }
  }
}
</style>